import Vue from 'vue'
import "babel-polyfill"
import App from './App.vue'
import router from './router'
import axios from 'axios'
import store from './store/store'
import Vuelidate from 'vuelidate'
import VModal from 'vue-js-modal'

axios.interceptors.request.use((request) => {
  request.headers['Authorization'] = store.getters.getStateIdToken;

  // IE11対策、request時キャッシュ削除
  if (typeof request.params === 'undefined') {
    request.params = {};
  }
  if (typeof request.params === 'object') {
    if (typeof URLSearchParams === 'function' && request.params instanceof URLSearchParams)
      request.params.append('_', Date.now());
    else
      request.params._ = Date.now();
  }

  return request
});

axios.interceptors.response.use(response => response, (error) => {
  if (error && error.response && error.response.status) {
    // 401 権限エラー, 403 認証エラー
    if (error.response.status === 401 || error.response.status === 403) {
      if (store.getters.getStateIsAdmin) {
        store.commit('logout');
        router.push({ name: 'loginAdmin' })
      } else {
        store.commit('logout');
        router.push({ name: 'login' })
      }
    }
  }
  return Promise.reject(error);
});

/* axios */
Vue.prototype.$axios = axios

/* Vuelidate */
Vue.use(Vuelidate)

/* VModal */
Vue.use(VModal)

/* vue-moment ※日付処理ライブラリ */
import moment from 'vue-moment'
Vue.use(moment)

/* lodash ※ソート処理ライブラリ */
import lodash from 'lodash'
Object.defineProperty(Vue.prototype, '$lodash', { value: lodash })

/* bootstrap */
import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)

/* プロダクションヒントの設定 */
Vue.config.productionTip = false

new Vue({
  store : store,
  router : router,
  render: h => h(App)
}).$mount('#app')
